import LocalStorageUtility from 'common/utility/localStorageUtility';
import { riskIntelligenceTranslations } from 'translations';

const riskIntelligenceMenuItems = _rootMenu;



const riAccountInfo = LocalStorageUtility.getData('riAccountInfo');



function _rootMenu() {
    return {
        i18n: riskIntelligenceTranslations.ng_common_eventFeed,
        linkTitle: 'Event Feed',
        routeTo: '/riskintelligence',
        isRenderable: true,
        accessConfiguration: permissions => !!riAccountInfo
            
    };
}

export default riskIntelligenceMenuItems;

